module.exports = __webpack_public_path__ + "5080d6f523c14f8bc7cff2e7e01f2953.png";